import React, { Component } from 'react';

import { translate } from 'components/translate';
import { stripPTag } from 'helpers/String';
import PropTypes from 'prop-types';

import UserDetailService from './UserDetailService';

import { I18n } from '../../../components/translate';

import './UserDetailQuizInfo.scss';

@translate()
export default class UserDetailQuizInfo extends Component {
  static propTypes = {
    t: PropTypes.func,
    quiz: PropTypes.object
  };

  answerIcon(item) {
    return item.answer === item.correctAnswer || !item.correctAnswer
      ? 'icon icon-check icon-rounded icon-success'
      : 'icon icon-close icon-rounded icon-failed';
  }

  renderResultInfo(quiz) {
    const { hitPercentage, hits, quizResult } = quiz;

    if (UserDetailService.isQuizProfile(quiz)) {
      return stripPTag(quiz.quizProfile.name);
    } else if (quizResult && quizResult.length) {
      return (
        <I18n
          label="users_manager.users_detail.hits_from_total"
          data={{ hitPercentage, hits, totalResult: quizResult.length }}
        />
      );
    }

    return null;
  }

  renderAnswer = (item) => {
    const { questionOrder, question, answer } = item;

    return (
      <li>
        <div>
          <i className={this.answerIcon(item)} />
        </div>
        <div>
          <h3 className="user-detail-quiz-info__answers__question">
            {`${questionOrder}. ${stripPTag(question)}`}
          </h3>
          <p className="user-detail-quiz-info__answers__answer">
            {stripPTag(answer)}
          </p>
        </div>
      </li>
    );
  };

  renderQuestionsList(quiz) {
    const { quizResult } = quiz;

    if (!quizResult) {
      return null;
    }

    return (
      <div className="user-detail-quiz-info__answers">
        <h2 className="user-detail-quiz-info__subtitle">
          <I18n label="general.answers" />
        </h2>
        <ul>{quizResult.map(this.renderAnswer)}</ul>
      </div>
    );
  }

  render() {
    const { quiz } = this.props;

    return (
      <div className="user-detail-quiz-info">
        <h1 className="user-detail-quiz-info__title">{quiz.title}</h1>
        <div className="user-detail-quiz-info__result">
          <h2 className="user-detail-quiz-info__subtitle">
            <I18n label="general.result" />
          </h2>
          <p>{this.renderResultInfo(quiz)}</p>
        </div>
        {this.renderQuestionsList(quiz)}
      </div>
    );
  }
}
